/**
 * Created by lu on 2018/4/8.
 */
var nb = require('../../../nb');
module.exports = nb.define({
    view: {
        'class': 'page-content',
        $html: [{
            $type: require('./banner/Banner'),
            $model: 'banner'
        }, {
            $type: require('./products/Products'), //商品推荐
            $model: 'products'
        }, {
            $type: require('./register/Register'), //采购流程
            $model: 'register'
        }, {
            $type: require('./wineType/TypeList'), //酒类推荐
            $model: 'typeList'
        }, {
            $type: require('./brand/BrandList'),  //品牌推荐
            $model: 'brandList'
        }, {
            $type: require('./bottom/Section'),    //订阅提交
            $model:'bottom'
        }]
    },
    method:{
        init:function () {
            var self = this;

        }

    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/Content.js
// module id = 505
// module chunks = 6